import type { AddressComponents } from '@/lib/address';
import { consumerUrl, opendoorUrl } from '@/lib/urls';

interface CreateSellerInputResponse {
  error?: boolean;
  uuid?: string;
}

// Omitting `channel` matches the production homepage and lets Reception default
// to its DEFAULT channel; the estimator passes HOME_VALUE for attribution.
export async function startSellerFlow(
  components: AddressComponents,
  channel?: 'HOME_VALUE',
): Promise<void> {
  try {
    const res = await fetch('/_address-input/create-seller-input', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        address: {
          street1: components.street,
          unit: components.unit ?? '',
          city: components.city,
          state: components.state,
          postal_code: components.postalCode,
        },
        ...(channel ? { channel } : {}),
        analyticsMetadata: { product: 'SELL_DIRECT', url: window.location.href },
      }),
    });
    const data = (await res.json()) as CreateSellerInputResponse;
    if (!res.ok || data.error || !data.uuid) {
      throw new Error('create-seller-input failed');
    }
    window.location.href = consumerUrl(`/seller-lead/${data.uuid}`);
  } catch {
    window.location.href = opendoorUrl('/address-entry');
  }
}
